<template>
  <router-link
    :to="'/donate'"
    target="_blank"
    class="donateBtn text-white"
  >
    <div
      class="donateSum donate_bg"
      :style="{ backgroundImage: 'url(' + image + ')' }"
    >
      <div class="donateHead">
        {{ $t('app_title') }} {{ osc_year }}
      </div>
      <div class="donateDesc">
        <p
          v-if="donation_figure"
          class="amount mb-0"
        >
          <span class="dollarSign">HK$</span>
          <span style="font-size:33px">{{ donation_figure }}</span>
        </p>
        <p
          v-if="!donation_figure"
          class="mb-0"
        >
          {{ $t('message.donate_now') }}
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>
import * as _ from "lodash";
export default {
  name: "DonateBtn",
  data: function() {
    return {
      image: this.getAssetLink("/assets/media/theme/img_santa_flip.png"),
      // osc_year: localStorage.osc_year,
      osc_year: localStorage.proposal_year, // TEMP
      donation_figure: _.isEmpty(localStorage.donation_figure)
        ? null
        : localStorage.donation_figure
    };
  }
};
</script>